import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { fetchContribution, fetchSalesPage, type SalesFilters } from '@/lib/salesOverview';
import type { SaleWithCustomer } from './useSales';

export function useSalesContribution(filters: SalesFilters) {
  const { organization, profile, access, can } = useAuth();
  return useQuery({
    queryKey: [
      'sales_contribution',
      organization?.id,
      profile?.id,
      access?.access_version,
      filters,
    ],
    queryFn: () => fetchContribution(filters),
    enabled:
      !!organization &&
      (!filters.from || !filters.to || filters.from <= filters.to) &&
      filters.from !== '' &&
      filters.to !== '' &&
      can(filters.scope === 'team' ? 'sales_contribution.view_all' : 'sales_contribution.view_own'),
    staleTime: 15000,
    refetchInterval: 60000,
  });
}
export function useContributionOrders(filters: SalesFilters) {
  const { organization, profile, access, can } = useAuth();
  return useQuery({
    queryKey: [
      'sales_contribution_orders',
      organization?.id,
      profile?.id,
      access?.access_version,
      filters,
    ],
    queryFn: () => fetchSalesPage<SaleWithCustomer>(filters),
    enabled:
      !!organization &&
      (!filters.from || !filters.to || filters.from <= filters.to) &&
      filters.from !== '' &&
      filters.to !== '' &&
      can(filters.scope === 'team' ? 'sales_contribution.view_all' : 'sales_contribution.view_own'),
    staleTime: 15000,
    refetchInterval: 60000,
  });
}
